import { render, staticRenderFns } from "./HBox.vue?vue&type=template&id=148f926a"
import script from "./HBox.vue?vue&type=script&lang=js"
export * from "./HBox.vue?vue&type=script&lang=js"
import style0 from "./HBox.vue?vue&type=style&index=0&id=148f926a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports